import { gt } from "$json";
(function ($) {
  $(function () {
    gt.addTranslations({
      "describe the problem": { nl: " " },
      "Please do not collate issues.": { nl: " " },
      "Please send only feedback about the currently visible question or questions; information about these will be sent back to the developers.":
        {
          nl: "Geef alleen feedback over de vraag die nu zichtbaar is in het scherm; de plaats in het model wordt meegezonden met de input."
        }
    });
  });
})(jQuery);
